import { Grid } from "@tine/designsystem-ui-react";
import { observer } from "mobx-react-lite";

import type { ContentfulAdventCalendarSlot } from "../../../common/types/cmsTypes";

import AdventCalendarSlot from "./AdventCalendarSlot";

type AdventCalendarProps = {
   adventCalendar: ContentfulAdventCalendarSlot[];
   trackingListName?: string;
};

const AdventCalendar = ({ adventCalendar, trackingListName }: AdventCalendarProps) => {
   return (
      <Grid cols={{ base: 2, sm: 3, md: 4, xl: 5 }} gap={4}>
         {adventCalendar.map((adventCalendarSlot) => {
            if (adventCalendarSlot.fields.slotImage) {
               return (
                  <AdventCalendarSlot
                     key={`advent-calendar-slot-${adventCalendarSlot.sys.id}`}
                     content={adventCalendarSlot}
                     trackingListName={trackingListName}
                  />
               );
            }
            return null;
         })}
      </Grid>
   );
};

export default observer(AdventCalendar);
